import { Injectable } from '@angular/core';
import { GeneralContractorClient } from '@api/api';
import { MsalService } from '@azure/msal-angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { IdentityActions } from './identity.actions';

@Injectable()
export class IdentityEffects {
  getUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IdentityActions.fetchIdentity),
      exhaustMap(() =>
        of(this.msalService.instance.getAllAccounts()[0]).pipe(
          map(account => IdentityActions.fetchIdentitySucceeded({ account }))
        )
      )
    )
  );

  getGeneralContractor$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IdentityActions.fetchIdentitySucceeded),
      exhaustMap(({ account }) => {
        if (account?.idTokenClaims?.extension_ContractorNumber) {
          return this.generalContractorClient
            .get(account?.idTokenClaims?.extension_ContractorNumber as string)
            .pipe(
              map(generalContractor =>
                IdentityActions.fetchGeneralContractorSucceeded({ generalContractor })
              ),
              catchError(() => of(IdentityActions.fetchGeneralContractorFailed()))
            );
        } else {
          return of(IdentityActions.noContractorNumberPresentInToken());
        }
      })
    )
  );

  constructor(
    private actions$: Actions,
    private msalService: MsalService,
    private generalContractorClient: GeneralContractorClient
  ) {}
}
